// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__y4qXy","noInvites":"styles_noInvites__l__7N"};